import React from 'react';
import { SectionInstance } from '../types';
import { getf } from './sectionHelpers';

const VARIANT_STYLES: Record<string, { bg: string; color: string }> = {
  dark:  { bg: '#1e293b', color: 'rgba(255,255,255,0.7)' },
  teal:  { bg: '#0f766e', color: 'rgba(255,255,255,0.85)' },
  navy:  { bg: '#0f172a', color: 'rgba(255,255,255,0.7)' },
  light: { bg: '#f8fafc', color: '#64748b' },
};

const FooterMinimal: React.FC<{ section: SectionInstance }> = ({ section }) => {
  const c = section.controls;
  const variant = c.variant || section.variant || 'dark';
  const scheme = VARIANT_STYLES[variant] || VARIANT_STYLES.dark;

  const bg    = c.background_color || scheme.bg;
  const color = c.text_color || scheme.color;
  const links = (c.links || []) as Array<{ label: string; url: string }>;
  // copyright → copyright_text fallback
  const copyright = getf(c, 'copyright_text', 'copyright') || String(new Date().getFullYear());

  return (
    <footer style={{ background: bg, color, padding: '24px' }}>
      <div style={{
        maxWidth: 1200, margin: '0 auto',
        display: 'flex', justifyContent: 'space-between', alignItems: 'center',
        flexWrap: 'wrap', gap: 12,
      }}>
        <p style={{ margin: 0, fontSize: '0.875rem' }}>&copy; {copyright}</p>
        <div style={{ display: 'flex', alignItems: 'center' }}>
          {links.map((l, i) => (
            <React.Fragment key={i}>
              {i > 0 && <span style={{ margin: '0 8px', opacity: 0.5 }}>·</span>}
              <a href={l.url || '#'} style={{ color, textDecoration: 'none', fontSize: '0.875rem' }}>
                {l.label}
              </a>
            </React.Fragment>
          ))}
        </div>
      </div>
    </footer>
  );
};

export default FooterMinimal;
